/* eslint-disable */
import { ChangeEvent, useContext, useEffect, useState } from 'react'
import PlatformLayout from '../../components/PlatformLayout'
import SearchParameters from './SearchParameters'
import { Outlet, useNavigate } from 'react-router-dom'
import { searchClient } from '../../apiCalls/searchApi'
import IsSearchingCircle from './IsSearchingCircleAndInfo'
import { useApiGet } from '../../apiCalls/useApi'
import { OrgAppContext } from '../../OrgAppContext'

export default function Client() {
  const { appId } = useContext(OrgAppContext)
  const [searchID, setSearchID] = useState<string>('')
  const [firstname, setFirstname] = useState<string>('')
  const [lastname, setLastname] = useState<string>('')
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const fetchClient = useApiGet(searchClient)
  const navigate = useNavigate()

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const id = searchParams.get('searchID')
    setSearchID((id as string) || '')
  }, [location.search])

  const handleSearchId = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchID(event.target.value)
  }
  const handleFirstname = (event: ChangeEvent<HTMLInputElement>) => {
    setFirstname(event.target.value)
  }

  const handleLastname = (event: ChangeEvent<HTMLInputElement>) => {
    setLastname(event.target.value)
  }

  const onSearch = async () => {
    if (searchID !== '' || firstname !== '' || lastname !== '') {
      setIsLoading(true)

      const clientResult = await fetchClient({
        appId,
        id: searchID,
        firstName: firstname,
        lastName: lastname,
      })
      if (clientResult && !clientResult.error && clientResult.data) {
        setIsLoading(false)
        navigate('clientsResult', { state: { clientResult: clientResult.data } })
      }
    }
  }

  return (
    <div
      style={{
        width: '100%',
        marginLeft: '15px',
        height: 'calc(100vh - 116px)',
        //   overflow: 'auto',
        //   backgroundColor:'blue'
      }}
    >
      <SearchParameters
        title='Client Search Parameters'
        searchID={searchID}
        firstname={firstname}
        lastname={lastname}
        handleSearchId={handleSearchId}
        handleFirstname={handleFirstname}
        handleLastname={handleLastname}
        onSearch={onSearch}
      />
      {isLoading ? <IsSearchingCircle /> : <Outlet />}
    </div>
  )
}
